/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type TreatmentExperienceLevel =
  (typeof TreatmentExperienceLevel)[keyof typeof TreatmentExperienceLevel];

export const TreatmentExperienceLevel = {
  New: "New",
  Somewhat: "Somewhat",
  Experienced: "Experienced",
} as const;
